import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalBadges } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-ivory py-10 sm:py-12" aria-labelledby="final-cta-heading" data-id="element-63" data-mp="3lw9eanbv0hzt">
      <div className="mx-auto max-w-4xl px-6" data-id="element-64" data-mp="3vsm6thvo4psz">
        <div className="rounded-4xl bg-sage-deep px-7 py-10 text-center shadow-lift sm:px-12" data-id="element-65" data-mp="3vrb7pvd64687">
          <p className="eyebrow text-gold-soft" data-id="element-66" data-mp="2y66qwkiw407j">Your next class</p>
          <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-xl font-display text-[2rem] leading-[1.12] text-ivory sm:text-4xl" data-id="element-67" data-mp="333fbssvfaich">
            Your next class doesn’t have to start with a blank page.
          </h2>
          <p className="mx-auto mt-4 max-w-lg font-display text-xl leading-snug text-gold-soft" data-id="element-68" data-mp="3cuthxjhvqgel">
            It can start with Yoga Teaching Vault™.
          </p>

          <CtaButton size="large" className="mt-9" data-id="element-69" data-mp="2kdh2yajswl7s">
            Get the complete Vault — $27
          </CtaButton>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-70" data-mp="2dcjl3jvmip2t">
            {finalBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-ivory/70" data-id="element-71" data-mp="28dyjbg0q3xc9">
                <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={2.4} aria-hidden="true" data-id="element-72" data-mp="23l5hazwn333v" />
                {badge}
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-10 max-w-xl text-center font-display text-xl leading-snug text-ink" data-id="element-73" data-mp="1ul8tf0i2q89v">
          Your energy belongs in the room with your students — not on another
          Sunday night staring at a blank class plan.
        </p>
      </div>
    </section>;
}